<div class="shell" *transloco="let t; prefix: 'licensing.authCallback'">
  <div class="callback-wrap" aria-live="polite" role="status">
    <div class="card">
      @switch (authState()) {
        @case ('exchanging') {
          <div class="status-icon loading">
            <img class="logo-image" [src]="faviconUrl" [alt]="t('logoAlt')" />
          </div>
          <h1 class="callback-title">{{ t('exchanging.title') }}</h1>
          <p class="callback-subtext">{{ t('exchanging.subtext') }}</p>
        }
        @case ('authenticated') {
          <div class="status-icon success">
            <img class="logo-image" [src]="faviconUrl" [alt]="t('logoAlt')" />
          </div>
          <h1 class="callback-title">{{ t('authenticated.title') }}</h1>
          <p class="callback-subtext">{{ t('authenticated.subtext') }}</p>
        }
        @case ('error') {
          <div class="status-icon error" role="img" [attr.aria-label]="t('error.iconLabel')">
            <img class="logo-image" [src]="faviconUrl" [alt]="t('logoAlt')" />
          </div>
          <h1 class="callback-title">{{ t('error.title') }}</h1>
          <p class="callback-subtext">{{ t('error.subtext') }}</p>

          <details class="error-disclosure">
            <summary class="error-disclosure-summary">
              <span class="summary-text">{{ t('error.showDetails') }}</span>
              <span class="chevron-icon material-symbols-outlined" aria-hidden="true"> expand_more </span>
            </summary>
            <div
              class="error-disclosure-content"
              role="region"
              [attr.aria-label]="t('error.detailsRegionLabel')">
              <code class="error-code">{{ error() }}</code>
            </div>
          </details>

          <button
            id="auth-callback-retry-btn"
            class="btn-primary"
            type="button"
            (click)="onRetry()"
            [attr.aria-label]="t('error.retryAriaLabel')">
            {{ t('error.retry') }}
          </button>
        }
        @default {
          <div class="status-icon loading">
            <img class="logo-image" [src]="faviconUrl" [alt]="t('logoAlt')" />
          </div>
          <h1 class="callback-title">{{ t('processing.title') }}</h1>
        }
      }
    </div>
  </div>
</div>
